export const createClrsReducer = (state = {}, action) => {
  switch (action.type) {
    case "create":
      return { clrs: action.payload };
    default:
      return state;
  }
};
